'use client'

import { ServicesPageBlockDto } from '@/shared/api/strapi/requests/service'
import { GetLanguageMenuSettingsDto } from '@/shared/api/strapi/requests'
import { ContactForm } from '@/widgets/Contact/ContactForm'
import { ModalBlockDto } from '@/shared/api/strapi/requests/getModalsBlock'
import { ImageFill } from '@/shared/ui/image-fill'

export const Conclusion = ({
  conclusion: { conclusion_title, conclusion_image },
  settings,
  modalBlock,
}: {
  conclusion: ServicesPageBlockDto['data']['attributes']
  settings: GetLanguageMenuSettingsDto['dataSettings']
  modalBlock: ModalBlockDto
}) => {
  return (
    <>
      <h2>{conclusion_title}</h2>
      <div className={'w-full grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-x-8 gap-y-4'}>
        <div className={'relative w-full h-[470] md:h-[690] xl:h-[380]'}>
          <ImageFill
            className={'object-cover rounded-2xl'}
            src={conclusion_image?.data.attributes.url || ''}
            alt={conclusion_image?.data.attributes.alternativeText || ''}
          />
        </div>
        <div className={'max-w-7xl flex flex-col w-full gap-4'}>
          <ContactForm modalBlock={modalBlock} settings={settings} />
        </div>
      </div>
    </>
  )
}
